export default class WebEvaluation2SaveRequest {
  itemId = [];
  stickerId = [];

  constructor(data) {
    // dataの各keyとvalueをペアとしてitemIdとstickerIdに格納
    for (const [itemId, stickerId] of Object.entries(data)) {
      if (itemId !== "listId" && itemId !== "termId") {
        this.itemId.push(itemId);
        this.stickerId.push(stickerId);
      }
    }
  }
}
